<template>
    <div class="client-container">
        <template v-if="!client?.name">
            <div class="alert alert-danger" role="alert">
                SFTP client does not exists
            </div>
            <button @click="createRFTClient" class="btn btn-primary">Create SFTP client</button>
        </template>
        <template v-else-if="!client.isActive">
            <div class="alert alert-warning" role="alert">
                SFTP client is inactive
            </div>
            <button @click="activateRFTClient" class="btn btn-primary">Activate SFTP client</button>
        </template>
        <template v-else>
            <div class="alert alert-success" role="alert">
                SFTP client is active
            </div>
            <button @click="deactivateRFTClient" class="btn btn-danger">Deactivate SFTP client</button>
        </template>
        <template v-if="clientExists">
            <hr>
            <h2>Accounts</h2>
            <client-accounts :company-id="companyId"></client-accounts>
            <hr>
            <h2>Files</h2>
            <client-files class="mt-2" :company-id="companyId"></client-files>
        </template>
        <loading-overlay :loading="isLoading"></loading-overlay>
    </div>
</template>

<script>
import LoadingOverlay from "../../components/LoadingOverlay.vue";
import ClientFiles from "./ClientFiles.vue";
import ClientAccounts from "./ClientAccounts.vue";
export default {
    components: {
        LoadingOverlay,
        ClientFiles,
        ClientAccounts
    },
    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            client: {},
        };
    },
    mounted() {
        this.isLoading = true;

        axios
            .get(route('rft.clients.show', { company: this.companyId }))
            .then(({ data }) => {
                this.isLoading = false
                this.client = data;
            })
            .catch((error) => {
                this.isLoading = false
                console.error(error);
            });
    },
    methods: {
        createRFTClient() {
            this.isLoading = true;

            axios
                .post(route('rft.clients.store', { company: this.companyId }))
                .then(({ data }) => {
                    this.client = data;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => this.isLoading = false);
        },
        activateRFTClient() {
            this.isLoading = true;

            axios
                .post(route('rft.clients.activate', { company: this.companyId }))
                .then(({ data }) => {
                    this.client = data;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => this.isLoading = false);
        },
        deactivateRFTClient() {
            this.isLoading = true;

            axios
                .post(route('rft.clients.deactivate', { company: this.companyId }))
                .then(({ data }) => {
                    this.client = data;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => this.isLoading = false);
        },
    },
    computed: {
        clientExists() {
            return Object.hasOwn(this.client, 'isActive');
        },
    },
};
</script>

<style lang="scss" scoped>
.client-container {
    position: relative;

    .disable-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.9);
    }
}
</style>
